import React, { useRef, forwardRef,useImperativeHandle } from 'react'
import { actionTypes } from '../reducer';
import { Grid } from '@mui/material';
import { ButtonGroup, Button } from '@mui/material';
import { useStateValue } from '../StateProvider';


function StepButtons({updateInfo,prevBtn,nextBtn,nextText=null,skipHauling,prevSkipHauling},ref) {
    const [{ applicantDetails, activeStep, goToStep, progressStep }, dispatch] = useStateValue();
    let plusStep = 1;
    let minusStep = 1;
    if (skipHauling == "true") plusStep = 2;
    if (prevSkipHauling == "true") minusStep = 2;

    const nextStep = () => {
        let updated = updateInfo();
        if (!updated.error) {
            dispatch({
                type: actionTypes.SET_ACTIVE_STEP,
                activeStep: activeStep + plusStep
            });
            if(progressStep < (activeStep + plusStep)){
                dispatch({
                    type: actionTypes.SET_PROGRESS_STEP,
                    progressStep: activeStep + plusStep
                });
            }
        } else {
            dispatch({
                type: actionTypes.SET_SHOW_NOTIFICATION,
                showNotification: {
                    show: true,
                    title: "Form Validation.",
                    content: updated.msg,
                    success: false
                }
            });
        }
        //console.log("activeStep",activeStep);
    }

    const previousStep = () => {
        updateInfo();
        dispatch({
            type: actionTypes.SET_ACTIVE_STEP,
            activeStep: activeStep - minusStep
        });
    }

    const customStep = (step) => {
        //console.log("customstep");
        let updated = updateInfo();
        //console.log("updated",updated);
        if (step > activeStep) {
            //console.log("greater than step", step);
            if (!updated.error) {
                dispatch({
                    type: actionTypes.SET_ACTIVE_STEP,
                    activeStep: step
                });
                if(progressStep < step){
                    dispatch({
                        type: actionTypes.SET_PROGRESS_STEP,
                        progressStep: step
                    });
                }
            } else {
                dispatch({
                    type: actionTypes.SET_SHOW_NOTIFICATION,
                    showNotification: {
                        show: true,
                        title: "Form Validation.",
                        content: updated.msg,
                        success: false
                    }
                });
            }
        } else if(step < activeStep) {
            //console.log("less than step", step);
            dispatch({
                type: actionTypes.SET_ACTIVE_STEP,
                activeStep: step
            });
        }

        
        
        //console.log("activeStep",activeStep);
        //set a trigger to stop useEffect
    }

    useImperativeHandle(ref, () => {
        return {
            customStepHandle: (step) => {
                customStep(step);
            }
          }
    }, [updateInfo]);
    
  return (
    <Grid container direction="column" spacing={2}>
        <Grid item xs={12} marginTop={6}>
            <ButtonGroup variant="contained" aria-label="outlined primary button group" style={{width: '200px'}}>
                {prevBtn != false  &&
                    <Button sx={{background: '#d3d3d3'}} fullWidth onClick={previousStep}>Previous</Button>
                }
                {nextBtn != false  &&
                      <Button fullWidth onClick={nextStep}>{nextText != null ? nextText :"Next"}</Button>
                }
            </ButtonGroup>
        </Grid>
    </Grid> 
  )
}

export default forwardRef(StepButtons);